module.exports = __webpack_public_path__ + "img/3.f48f4de8.png";